import { setViewAs } from './api.ts';

/**
 * Which data a local `npm run dev` is working on (dev-proxy.ts): this
 * machine's database, or production's, through the production API. Only a
 * development build has the switch; the deployed portal is always itself.
 */
export type Environment = 'local' | 'production';

export function currentEnvironment(): Environment | null {
  if (!import.meta.env.DEV) return null;
  return /(?:^|;\s*)nsb_env=production(?:;|$)/.test(document.cookie) ? 'production' : 'local';
}

/** Switch, and start again from the top: projects, people and sessions are different on each side. */
export function switchEnvironment(to: Environment): void {
  document.cookie = to === 'production' ? 'nsb_env=production; path=/; max-age=31536000; samesite=lax' : 'nsb_env=; path=/; max-age=0; samesite=lax';
  setViewAs(null);
  window.location.assign('/');
}
